import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_DATA_FLOW_LANG: {
  DATA_FLOW_LIST_CURRENT: MvnCodeFE;
  DATA_FLOW_LIST_LIST: MvnCodeFE;
  DATA_FLOW_LIST_MENU_RENAME: MvnCodeFE;
  DATA_FLOW_LIST_MENU_DELETE: MvnCodeFE;
  DATA_FLOW_TOAST_RENAME_SUCCEED: MvnCodeFE;
  DATA_FLOW_TOAST_RENAME_FAIL: MvnCodeFE;
  DATA_FLOW_DIALOG_DELETE_DESCRIPTION: MvnCodeFE;
  DATA_FLOW_DIALOG_DRAFT_DELETE_DESCRIPTION: MvnCodeFE;
  DATA_FLOW_TOAST_DELETE_SUCCEED: MvnCodeFE;
  DATA_FLOW_TOAST_DELETE_FAIL: MvnCodeFE;
  DATA_FLOW_DIALOG_DELETED_DESCRIPTION: MvnCodeFE;
  DATA_FLOW_TOAST_DELETED_DESCRIPTION: MvnCodeFE;
  DATA_FLOW_ORIGINAL_DELETED_TOOLTIP: MvnCodeFE;
  BOARD_TITLE: MvnCodeFE;
  BOARD_EMPTY_TITLE: MvnCodeFE;
  BOARD_EMPTY_DESCRIPTION: MvnCodeFE;
  BOARD_BUTTON_NEW_FLOW: MvnCodeFE;
  BOARD_BUTTON_REFLOW: MvnCodeFE;
  BOARD_TOAST_REFLOW_DESCRIPTION: MvnCodeFE;
  BOARD_REFLOW_SUCCEED: MvnCodeFE;
  BOARD_REFLOW_FAIL: MvnCodeFE;
  BOARD_REFLOW_PRIVILEGE_FAIL: MvnCodeFE;
  BOARD_MENU_NEW_FLOW: MvnCodeFE;
  BOARD_MENU_IMPORT_DATASET: MvnCodeFE;
  BOARD_MENU_RESTORE: MvnCodeFE;
  BOARD_MENU_RESET: MvnCodeFE;
  BOARD_MENU_SAVE_AS: MvnCodeFE;
  BOARD_MENU_SAVE: MvnCodeFE;
  BOARD_DIALOG_NEW_FLOW_IMPORT_DATASET_TITLE: MvnCodeFE;
  BOARD_DIALOG_NEW_FLOW_IMPORT_DATASET_DESCRIPTION: MvnCodeFE;
  BOARD_DIALOG_IMPORT_DATASET_TITLE: MvnCodeFE;
  BOARD_DIALOG_IMPORT_DATASET_DESCRIPTION: MvnCodeFE;
  BOARD_DIALOG_RESET_TITLE: MvnCodeFE;
  BOARD_DIALOG_RESET_DESCRIPTION: MvnCodeFE;
  BOARD_TOAST_IMPORT_DATASET_SUCCEED: MvnCodeFE;
  BOARD_TOAST_IMPORT_DATASET_FAIL: MvnCodeFE;
  BOARD_TOAST_RESTORE_SUCCEED: MvnCodeFE;
  BOARD_TOAST_RESTORE_FAIL: MvnCodeFE;
  BOARD_TOAST_RESET_SUCCEED: MvnCodeFE;
  BOARD_TOAST_RESET_FAIL: MvnCodeFE;
  BOARD_TOAST_SAVE_SUCCEED: MvnCodeFE;
  BOARD_TOAST_SAVE_FAIL: MvnCodeFE;
  BOARD_DIALOG_SAVE_TITLE: MvnCodeFE;
  BOARD_DIALOG_SAVE_HELPER_TEXT: MvnCodeFE;
  BOARD_DIALOG_SAVE_AS_TITLE: MvnCodeFE;
  BOARD_DIALOG_SAVE_CONFLICT_DESCRIPTION: MvnCodeFE;
  BOARD_TOAST_SAVE_AS_SUCCEED: MvnCodeFE;
  BOARD_TOAST_SAVE_AS_FAIL: MvnCodeFE;
  BOARD_DIALOG_IMPORT_DATASET_SELECTED: MvnCodeFE;
  BOARD_DIALOG_RESTORE_TITLE: MvnCodeFE;
  BOARD_DIALOG_RESTORE_DESCRIPTION: MvnCodeFE;
  NODE_MENU_PIVOT: MvnCodeFE;
  NODE_MENU_UNION: MvnCodeFE;
  NODE_MENU_JOIN: MvnCodeFE;
  NODE_MENU_DTC_RANGE: MvnCodeFE;
  NODE_MENU_CLONE: MvnCodeFE;
  NODE_MENU_SDTM_MAPPING: MvnCodeFE;
  NODE_MENU_EDIT: MvnCodeFE;
  NODE_MENU_SAVE: MvnCodeFE;
  NODE_MENU_RENAME: MvnCodeFE;
  NODE_MENU_DELETE: MvnCodeFE;
  NODE_DIALOG_PIVOT_TITLE: MvnCodeFE;
  NODE_DIALOG_PIVOT_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_PIVOT_PLACEHOLDER: MvnCodeFE;
  NODE_TOAST_PIVOT_SUCCEED: MvnCodeFE;
  NODE_TOAST_PIVOT_FAIL: MvnCodeFE;
  NODE_DIALOG_UNION_TITLE: MvnCodeFE;
  NODE_DIALOG_UNION_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_UNION_PLACEHOLDER: MvnCodeFE;
  NODE_DIALOG_UNION_HELPER_TEXT: MvnCodeFE;
  NODE_DIALOG_UNION_EMPTY: MvnCodeFE;
  NODE_TOAST_UNION_SUCCEED: MvnCodeFE;
  NODE_TOAST_UNION_FAIL: MvnCodeFE;
  NODE_DIALOG_JOIN_TITLE: MvnCodeFE;
  NODE_DIALOG_JOIN_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_JOIN_DATASET_PLACEHOLDER: MvnCodeFE;
  NODE_DIALOG_JOIN_KEY_PLACEHOLDER: MvnCodeFE;
  NODE_TOAST_JOIN_SUCCEED: MvnCodeFE;
  NODE_TOAST_JOIN_FAIL: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_TITLE: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_KEYS_PLACEHOLDER: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_DATASET_PLACEHOLDER: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_VARIABLE_PLACEHOLDER: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_TYPE_VALIDATION: MvnCodeFE;
  NODE_DIALOG_DTC_RANGE_DATASET_VALIDATION: MvnCodeFE;
  NODE_TOAST_DTC_RANGE_SUCCEED: MvnCodeFE;
  NODE_TOAST_DTC_RANGE_FAIL: MvnCodeFE;
  NODE_TOAST_CLONE_SUCCEED: MvnCodeFE;
  NODE_TOAST_CLONE_FAIL: MvnCodeFE;
  NODE_TOAST_SAVE_SUCCEED: MvnCodeFE;
  NODE_TOAST_SAVE_FAIL: MvnCodeFE;
  NODE_DIALOG_DELETE_TITLE: MvnCodeFE;
  NODE_DIALOG_DELETE_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_DELETE_USAGE_DESCRIPTION: MvnCodeFE;
  NODE_TOAST_DELETE_SUCCEED: MvnCodeFE;
  NODE_TOAST_DELETE_FAIL: MvnCodeFE;
  NODE_TOAST_NAME_EXISTS: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_TITLE: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_EMPTY_TITLE: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_EMPTY_DESCRIPTION: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SELECT_PLACEHOLDER: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_CONFIRM: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_CANCEL: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_PROGRESS: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_ONE_TO_ONE_SUCCEED: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_ONE_TO_ONE_FAIL: MvnCodeFE;
  NODE_DIALOG_SDTM_MAPPING_CT_TITLE: MvnCodeFE;
  NODE_DIALOG_SDTM_MAPPING_CT_DESCRIPTION: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_CT_SUCCEED: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_CT_FAIL: MvnCodeFE;
  NODE_DIALOG_SDTM_MAPPING_FACTOR_TITLE: MvnCodeFE;
  NODE_DIALOG_SDTM_MAPPING_FACTOR_DESCRIPTION: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SUCCEED: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_FACTOR_FAIL: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_NULL_SUCCEED: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_NULL_FAIL: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SUCCEED: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_FAIL: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_AUTO: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SEQ_EMPTY_KEY_TOOLTIP: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SEQ_INVALID_DEFAULT_KEY_TOOLTIP: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SEQ_UNMAPPED_TARGET_KEY_TOOLTIP: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SETTING_BUTTON: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SETTING_TOOLTIP: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_RETAIN_ALL_CHECKBOX: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SEQ_PARTITION_TITLE: MvnCodeFE;
  NODE_DRAWER_SDTM_MAPPING_SEQ_PARTITION_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_FLOW_SAVE_ALERT_TITLE: MvnCodeFE;
  NODE_DIALOG_FLOW_SAVE_ALERT_DERIVED_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_FLOW_SAVE_ALERT_SDTM_DESCRIPTION: MvnCodeFE;
  NODE_DIALOG_FLOW_SAVE_PLACEHOLDER: MvnCodeFE;
  NODE_EXPORT_SAVE_REQUIRED_ALERT: MvnCodeFE;
  NODE_EXPORT_SAVE_REQUIRED_TOOLTIP: MvnCodeFE;
  NODE_EXPORT_SAVE_PROGRESS: MvnCodeFE;
  NODE_SDTM_MAPPING_REQUIRED_ALERT: MvnCodeFE;
  NODE_SOURCE_NOT_FOUND_ALERT: MvnCodeFE;
  NODE_EXPORT_NOT_FOUND_ALRET: MvnCodeFE;
  NODE_EXECUTION_FAILED_ALRET: MvnCodeFE;
  NODE_ORPHAN_ALRET: MvnCodeFE;
  NODE_TOAST_EXPORT_DELETE_FAIL: MvnCodeFE;
  NODE_TOAST_EDIT_SUCCEED: MvnCodeFE;
  NODE_TOAST_EDIT_FAIL: MvnCodeFE;
  NODE_TOAST_SDTM_SAVE_FAIL: MvnCodeFE;
  NODE_DIALOG_SOURCE_IMPORT_CONFIRM_TITLE: MvnCodeFE;
  NODE_DIALOG_SOURCE_IMPORT_CONFIRM_DESCRIPTION: MvnCodeFE;
  NODE_TOAST_SOURCE_IMPORT_SUCCEED: MvnCodeFE;
  NODE_TOAST_SOURCE_IMPORT_SCHEMA_FAIL: MvnCodeFE;
  DATA_TABLE_TITLE: MvnCodeFE;
  DATA_TABLE_EMPTY: MvnCodeFE;
  DATA_TABLE_MENU_CREATE_DERIVED_VARIABLE: MvnCodeFE;
  DATA_TABLE_MENU_ORDER_BY: MvnCodeFE;
  DATA_TABLE_MENU_FILTER: MvnCodeFE;
  DATA_TABLE_MENU_HISTORY: MvnCodeFE;
  DATA_TABLE_MENU_REMOVE_DUPLICATES: MvnCodeFE;
  DATA_TABLE_MENU_PROCEDURE: MvnCodeFE;
  DATA_TABLE_MENU_PROCEDURE_VISITNUM: MvnCodeFE;
  DATA_TABLE_MENU_PROCEDURE_VISITNUM_TOOLTIP: MvnCodeFE;
  DATA_TABLE_DIALOG_ORDER_BY_TITLE: MvnCodeFE;
  DATA_TABLE_DIALOG_ORDER_BY_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_MENU_ORDER_BY_ADD: MvnCodeFE;
  DATA_TABLE_DIALOG_MENU_ORDER_BY_DELETE: MvnCodeFE;
  DATA_TABLE_DIALOG_TOOLTIP_ORDER_BY_ASC: MvnCodeFE;
  DATA_TABLE_DIALOG_TOOLTIP_ORDER_BY_DESC: MvnCodeFE;
  DATA_TABLE_TOAST_ORDER_BY_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_ORDER_BY_FAIL: MvnCodeFE;
  DATA_TABLE_DIALOG_FILTER_TITLE: MvnCodeFE;
  DATA_TABLE_DIALOG_FILTER_VARIABLE_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_FILTER_INPUT_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_FILTER_MENU_ADD: MvnCodeFE;
  DATA_TABLE_DIALOG_FILTER_MENU_DELETE: MvnCodeFE;
  DATA_TABLE_TOAST_FILTER_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_FILTER_FAIL: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_TITLE: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_ASC: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_DESC: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_UNDO: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_REDO: MvnCodeFE;
  DATA_TABLE_DIALOG_HISTORY_BADGE_FAIL: MvnCodeFE;
  DATA_TABLE_HISTORY_TOOLTIP_EDIT: MvnCodeFE;
  DATA_TABLE_HISTORY_TOOLTIP_DELETE: MvnCodeFE;
  DATA_TABLE_TOAST_HISTORY_DELETE_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_HISTORY_DELETE_FAIL: MvnCodeFE;
  DATA_TABLE_TOAST_HISTORY_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_HISTORY_FAIL: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_CREATE_DERIVED_VARIABLE: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_FILTER: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_CDISC: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_AGGREGATE: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_REMOVE_DUPLICATES: MvnCodeFE;
  DATA_TABLE_FIELD_MENU_DELETE: MvnCodeFE;
  DATA_TABLE_FIELD_SORT: MvnCodeFE;
  DATA_TABLE_FIELD_ASC: MvnCodeFE;
  DATA_TABLE_FIELD_DESC: MvnCodeFE;
  DATA_TABLE_POPOVER_AGGREGATE: MvnCodeFE;
  DATA_TABLE_POPOVER_AGGREGATE_EMPTY: MvnCodeFE;
  DATA_TABLE_POPOVER_TOOLTIP_AGGREGATE: MvnCodeFE;
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_TITLE: MvnCodeFE;
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_DESCRIPTION: MvnCodeFE;
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_TOAST_REMOVE_DUPLICATES_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_REMOVE_DUPLICATES_FAIL: MvnCodeFE;
  DATA_TABLE_TOAST_VARIABLE_DELETE_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_VARIABLE_DELETE_FAIL: MvnCodeFE;
  DATA_TABLE_TOAST_VARIABLES_DELETE_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_VARIABLES_DELETE_FAIL: MvnCodeFE;
  DATA_TABLE_TOAST_VARIABLE_RENAME_FAIL: MvnCodeFE;
  DATA_TABLE_FIELD_TYPE_DATE: MvnCodeFE;
  DATA_TABLE_FIELD_TYPE_DATETIME: MvnCodeFE;
  DATA_TABLE_FIELD_TYPE_TEXT: MvnCodeFE;
  DATA_TABLE_FIELD_TYPE_INTEGER: MvnCodeFE;
  DATA_TABLE_FIELD_TYPE_FLOAT: MvnCodeFE;
  DATA_TABLE_TOAST_TYPE_CASTING_SUCCESS: MvnCodeFE;
  DATA_TABLE_TOAST_TYPE_CASTING_FAIL: MvnCodeFE;
  DATA_TABLE_TOAST_UNSUPPORTED_TYPE_CASTING_FAIL: MvnCodeFE;

  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_TITLE: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_DESCRIPTION: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_SUBJECT_ID_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISITDTC_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISITNUM_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISIT_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_VALUE_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_FORMAT_PLACEHOLDER: MvnCodeFE;
  DATA_TABLE_TOAST_PROCEDURE_VISITNUM_SUCCEED: MvnCodeFE;
  DATA_TABLE_TOAST_PROCEDURE_VISITNUM_FAIL: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_DEFAULT_VISITNUM_CHIP: MvnCodeFE;
  DATA_TABLE_DIALOG_PROCEDURE_DEFAULT_VISIT_CHIP: MvnCodeFE;

  POPOVER_CDISC_INFORMATION: MvnCodeFE;

  FUNCTION_EDITOR_DRAWER_TITLE: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_VARIABLE_PLACEHOLDER: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_SEARCH_PLACEHOLDER: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_EXAMPLE_TEXT: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_ERROR_MESSAGE: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_CANCEL: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_COMMIT: MvnCodeFE;
  FUNCTION_EDITOR_DRAWER_EXECUTE: MvnCodeFE;

  FUNCTION_EDITOR_TOAST_EXECUTE_SUCCEED: MvnCodeFE;
  FUNCTION_EDITOR_TOAST_EXECUTE_FAIL: MvnCodeFE;
  FUNCTION_EDITOR_TOAST_COMMIT_SUCCEED: MvnCodeFE;
  FUNCTION_EDITOR_TOAST_COMMIT_FAIL: MvnCodeFE;

  FUNCTION_IS_NULL_DESCRIPTION: MvnCodeFE;
  FUNCTION_IF_NULL_DESCRIPTION: MvnCodeFE;
  FUNCTION_IF_DESCRIPTION: MvnCodeFE;
  FUNCTION_CASE_DESCRIPTION: MvnCodeFE;
  FUNCTION_ROUND_DESCRIPTION: MvnCodeFE;
  FUNCTION_SUBSTRING_DESCRIPTION: MvnCodeFE;
  FUNCTION_REPLACE_DESCRIPTION: MvnCodeFE;
  FUNCTION_CONCAT_DESCRIPTION: MvnCodeFE;
  FUNCTION_GREATEST_DESCRIPTION: MvnCodeFE;
  FUNCTION_LEAST_DESCRIPTION: MvnCodeFE;
  FUNCTION_STRPDATE_DESCRIPTION: MvnCodeFE;
  FUNCTION_STRPDATE_DETAIL: MvnCodeFE;
  FUNCTION_STRPTIME_DESCRIPTION: MvnCodeFE;
  FUNCTION_STRPTIME_DETAIL: MvnCodeFE;

  FUNCTION_WINDOW_RANK_DESCRIPTION: MvnCodeFE;
  FUNCTION_WINDOW_ROW_NUMBER_DESCRIPTION: MvnCodeFE;
  FUNCTION_WINDOW_DENSE_RANK_DESCRIPTION: MvnCodeFE;
  FUNCTION_WINDOW_MIN_DESCRIPTION: MvnCodeFE;
  FUNCTION_WINDOW_MAX_DESCRIPTION: MvnCodeFE;

  TOOLTIP_MORE: MvnCodeFE;
  DIALOG_SAVE: MvnCodeFE;
  DIALOG_CONFIRM: MvnCodeFE;
  DIALOG_CANCEL: MvnCodeFE;
  DIALOG_SAVEAS: MvnCodeFE;
} = {
  DATA_FLOW_LIST_CURRENT: {
    ko: "현재 흐름",
    en: "Current Flow",
  },
  DATA_FLOW_LIST_LIST: {
    ko: "흐름 목록",
    en: "Flow List",
  },
  DATA_FLOW_LIST_MENU_RENAME: {
    ko: "이름 변경",
    en: "Rename",
  },
  DATA_FLOW_LIST_MENU_DELETE: {
    ko: "삭제",
    en: "Delete",
  },
  DATA_FLOW_TOAST_RENAME_SUCCEED: {
    ko: "이름 변경을 완료했습니다.",
    en: "The name has been changed.",
  },
  DATA_FLOW_TOAST_RENAME_FAIL: {
    ko: "이름 변경에 실패했습니다.\n동일한 이름이 있습니다.",
    en: "Failed to change the name.\nA duplicate name exists.",
  },
  DATA_FLOW_DIALOG_DELETE_DESCRIPTION: {
    ko: "선택한 흐름을 삭제하시겠습니까?",
    en: "Do you want to delete the selected flow?",
  },
  DATA_FLOW_DIALOG_DRAFT_DELETE_DESCRIPTION: {
    ko: "저장되지 않은 흐름입니다.\n선택한 흐름을 삭제하시겠습니까?",
    en: "This flow has not been saved.\nDo you want to delete the selected flow?",
  },
  DATA_FLOW_TOAST_DELETE_SUCCEED: {
    ko: "흐름을 삭제 했습니다.",
    en: "The flow has been deleted.",
  },
  DATA_FLOW_TOAST_DELETE_FAIL: {
    ko: "흐름 삭제에 실패했습니다.",
    en: "Failed to delete the flow.",
  },
  DATA_FLOW_DIALOG_DELETED_DESCRIPTION: {
    ko: "원본 흐름이 서버에서 {name}({email})에 의해 {time}에 삭제되었습니다.\n\n새로운 흐름으로 저장하세요.",
    en: "The original flow was deleted from the server by {name}({email}) at {time}.\n\nPlease save it as a new flow.",
  },
  DATA_FLOW_TOAST_DELETED_DESCRIPTION: {
    ko: "해당 흐름의 원본이 서버에서 삭제되었습니다.\n해당 흐름을 삭제하거나 새로운 흐름으로 저장하세요.",
    en: "The original flow has been deleted from the server.\nPlease delete this flow or save it as a new flow.",
  },
  DATA_FLOW_ORIGINAL_DELETED_TOOLTIP: {
    ko: "원본 흐름 삭제됨",
    en: "Original flow deleted.",
  },
  BOARD_TITLE: {
    ko: "작업보드",
    en: "Board",
  },
  BOARD_EMPTY_TITLE: {
    ko: "등록된 데이터가 없습니다.",
    en: "No data has been registered.",
  },
  BOARD_EMPTY_DESCRIPTION: {
    ko: "버튼을 눌러 새 플로우를 생성하세요.",
    en: "Click the button to create a new flow.",
  },
  BOARD_BUTTON_NEW_FLOW: {
    ko: "새 흐름",
    en: "New Flow",
  },
  BOARD_BUTTON_REFLOW: {
    ko: "재흐름",
    en: "Reflow",
  },
  BOARD_TOAST_REFLOW_DESCRIPTION: {
    ko: "재수행이 필요합니다. [재흐름] 버튼을 눌러 주세요.",
    en: "Reflow is necessary. Please click the Reflow button.",
  },
  BOARD_REFLOW_SUCCEED: {
    ko: "흐름 재수행을 완료했습니다.",
    en: "The flow has been rerun.",
  },
  BOARD_REFLOW_FAIL: {
    ko: "흐름 재수행에 실패했습니다.",
    en: "Failed to rerun the flow.",
  },
  BOARD_REFLOW_PRIVILEGE_FAIL: {
    ko: "재흐름 수행 권한이 없습니다.",
    en: "You do not have permission to perform this action.",
  },
  BOARD_MENU_NEW_FLOW: {
    ko: "새 흐름",
    en: "New Flow",
  },
  BOARD_MENU_IMPORT_DATASET: {
    ko: "데이터 세트 가져오기",
    en: "Import Dataset",
  },
  BOARD_MENU_RESTORE: {
    ko: "흐름 복원",
    en: "Restore",
  },
  BOARD_MENU_RESET: {
    ko: "흐름 초기화",
    en: "Reset",
  },
  BOARD_MENU_SAVE_AS: {
    ko: "다른 이름으로 저장",
    en: "Save As",
  },
  BOARD_MENU_SAVE: CONVERTER_COMMON_LANG.SAVE_VERB,
  BOARD_DIALOG_NEW_FLOW_IMPORT_DATASET_TITLE: {
    ko: "새 흐름에 데이터 세트 추가하기",
    en: "Import Dataset in New Flow",
  },
  BOARD_DIALOG_NEW_FLOW_IMPORT_DATASET_DESCRIPTION: {
    ko: "사용할 데이터 세트를 선택해 주세요.",
    en: "Select the dataset to be used.",
  },
  BOARD_DIALOG_IMPORT_DATASET_TITLE: {
    ko: "데이터 세트 추가하기",
    en: "Import Dataset",
  },
  BOARD_DIALOG_IMPORT_DATASET_DESCRIPTION: {
    ko: "사용할 데이터 세트를 선택해 주세요.",
    en: "Select the dataset to be used.",
  },
  BOARD_TOAST_IMPORT_DATASET_SUCCEED: {
    ko: "데이터 세트를 추가했습니다.",
    en: "The dataset has been added to the board.",
  },
  BOARD_TOAST_IMPORT_DATASET_FAIL: {
    ko: "데이터 세트 추가에 실패했습니다.",
    en: "Failed to add the dataset to the board.",
  },
  BOARD_TOAST_RESTORE_SUCCEED: {
    ko: "흐름 복원을 완료했습니다.",
    en: "The flow restore has been completed.",
  },
  BOARD_TOAST_RESTORE_FAIL: {
    ko: "흐름 복원에 실패했습니다.",
    en: "Failed to restore the flow.",
  },
  BOARD_DIALOG_RESET_TITLE: {
    ko: "초기화",
    en: "Reset",
  },
  BOARD_DIALOG_RESET_DESCRIPTION: {
    ko: "현재 작업 중인 흐름을 초기화 하시겠습니까?",
    en: "Are you sure you want to reset the file you are currently working on?",
  },
  BOARD_TOAST_RESET_SUCCEED: {
    ko: "흐름 초기화를 완료했습니다.",
    en: "The flow reset has been completed.",
  },
  BOARD_TOAST_RESET_FAIL: {
    ko: "흐름 초기화에 실패했습니다.",
    en: "Failed to reset the flow.",
  },
  BOARD_DIALOG_SAVE_TITLE: CONVERTER_COMMON_LANG.SAVE_VERB,
  BOARD_DIALOG_SAVE_HELPER_TEXT: {
    ko: "중복된 파일 이름이 존재합니다. 다른 이름으로 저장해 주십시오.",
    en: "A duplicate file name exists. Please save it with a different name.A duplicate file exists.",
  },
  BOARD_TOAST_SAVE_SUCCEED: {
    ko: "흐름을 저장했습니다.",
    en: "The flow has been saved.",
  },
  BOARD_TOAST_SAVE_FAIL: {
    ko: "흐름 저장에 실패했습니다.",
    en: "Failed to save the flow.",
  },
  BOARD_DIALOG_SAVE_AS_TITLE: {
    ko: "다른 이름으로 저장",
    en: "Save as",
  },
  BOARD_DIALOG_SAVE_CONFLICT_DESCRIPTION: {
    ko: "이 흐름은 {name}({email})님께서 {time}에 먼저 저장한 이력이 확인되어 동일한 이름으로 저장이 불가합니다.\n\n다른 이름으로 저장해 주시기 바랍니다.",
    en: "This flow was updated by {name}({email}) on {time} and cannot be saved with the same name.\n\nPlease save it in a different name.",
  },
  BOARD_TOAST_SAVE_AS_SUCCEED: {
    ko: "다른 이름으로 저장했습니다.",
    en: "The Save As operation has been completed.",
  },
  BOARD_TOAST_SAVE_AS_FAIL: {
    ko: "다른 이름으로 저장에 실패했습니다.",
    en: "Failed to perform Save As.",
  },
  BOARD_DIALOG_IMPORT_DATASET_SELECTED: {
    ko: "개 선택됨",
    en: "items selected.",
  },
  BOARD_DIALOG_RESTORE_TITLE: {
    ko: "서버 저장 시점으로 복원",
    en: "Restore",
  },
  BOARD_DIALOG_RESTORE_DESCRIPTION: {
    ko: "흐름의 작업상태가 이전 서버 저장 시점으로 복원됩니다.\n복원하시겠습니까?",
    en: "The Flow's task status will be restored to the previous server save point.\nWould you like to proceed with the restoration?",
  },
  NODE_MENU_PIVOT: {
    ko: "피벗",
    en: "Pivot",
  },
  NODE_MENU_UNION: {
    ko: "유니온",
    en: "Union",
  },
  NODE_MENU_JOIN: {
    ko: "조인",
    en: "Join",
  },
  NODE_MENU_DTC_RANGE: {
    ko: "MAX(MIN)DTC 생성",
    en: "MAX(MIN)DTC Generation",
  },
  NODE_MENU_CLONE: {
    ko: "값으로 데이터 세트 복제",
    en: "Clone Dataset by Value",
  },
  NODE_MENU_SDTM_MAPPING: {
    ko: "SDTM 매핑",
    en: "SDTM Mapping",
  },
  NODE_MENU_EDIT: {
    ko: "설정 수정",
    en: "Edit Settings",
  },
  NODE_MENU_SAVE: CONVERTER_COMMON_LANG.SAVE_VERB,
  NODE_MENU_RENAME: {
    ko: "이름 변경",
    en: "Rename",
  },
  NODE_MENU_DELETE: {
    ko: "삭제",
    en: "Delete",
  },
  NODE_DIALOG_PIVOT_TITLE: {
    ko: "피벗",
    en: "Pivot",
  },
  NODE_DIALOG_PIVOT_DESCRIPTION: {
    ko: "피벗 종류를 선택해 주세요.",
    en: "Select a pivot type.",
  },
  NODE_DIALOG_PIVOT_PLACEHOLDER: {
    ko: "변수명 입력",
    en: "Enter the variable name",
  },
  NODE_TOAST_PIVOT_SUCCEED: {
    ko: "피벗 작업을 완료했습니다.",
    en: "The pivot operation has been completed.",
  },
  NODE_TOAST_PIVOT_FAIL: {
    ko: "피벗 작업에 실패했습니다.",
    en: "Failed to perform the pivot operation.",
  },
  NODE_DIALOG_UNION_TITLE: {
    ko: "유니온",
    en: "Union",
  },
  NODE_DIALOG_UNION_DESCRIPTION: {
    ko: "유니온 종류를 선택해 주세요.",
    en: "Select a union type.",
  },
  NODE_DIALOG_UNION_PLACEHOLDER: {
    ko: "데이터 세트 선택",
    en: "Select datasets",
  },
  NODE_DIALOG_UNION_HELPER_TEXT: {
    ko: "각 데이터 세트의 2개 행을 대상으로 결합을 수행하여 미리 보기 합니다.",
    en: "The union will be performed on two rows of each dataset, and a preview will be displayed.",
  },
  NODE_DIALOG_UNION_EMPTY: {
    ko: "데이터가 없습니다.",
    en: "There is no data.",
  },
  NODE_TOAST_UNION_SUCCEED: {
    ko: "유니온 작업을 완료했습니다.",
    en: "The union operation has been completed.",
  },
  NODE_TOAST_UNION_FAIL: {
    ko: "유니온 작업에 실패했습니다.",
    en: "Failed to perform the union operation.",
  },
  NODE_DIALOG_JOIN_TITLE: {
    ko: "조인",
    en: "Join",
  },
  NODE_DIALOG_JOIN_DESCRIPTION: {
    ko: "조인 종류를 선택해 주세요.",
    en: "Select the desired join type.",
  },
  NODE_DIALOG_JOIN_DATASET_PLACEHOLDER: {
    ko: "데이터 세트 선택",
    en: "Select dataset",
  },
  NODE_DIALOG_JOIN_KEY_PLACEHOLDER: {
    ko: "변수 선택",
    en: "Select variable",
  },
  NODE_TOAST_JOIN_SUCCEED: {
    ko: "조인 작업을 완료했습니다.",
    en: "The join operation has been completed.",
  },
  NODE_TOAST_JOIN_FAIL: {
    ko: "조인 작업에 실패했습니다.",
    en: "Failed to perform the join operation.",
  },
  NODE_DIALOG_DTC_RANGE_TITLE: {
    ko: "MAX(MIN)DTC 생성",
    en: "MAX(MIN)DTC Generation",
  },
  NODE_DIALOG_DTC_RANGE_DESCRIPTION: {
    ko: "MAX(MIN)DTC 생성 종류를 선택해 주세요.",
    en: "Select the desired DTC type.",
  },
  NODE_DIALOG_DTC_RANGE_KEYS_PLACEHOLDER: {
    ko: "그룹화 할 변수(들) 선택",
    en: "Select variable(s) to group by",
  },
  NODE_DIALOG_DTC_RANGE_DATASET_PLACEHOLDER: {
    ko: "데이터 세트 선택",
    en: "Select dataset",
  },
  NODE_DIALOG_DTC_RANGE_VARIABLE_PLACEHOLDER: {
    ko: "날짜 타입의 변수 선택",
    en: "Select a date type variable",
  },
  NODE_DIALOG_DTC_RANGE_TYPE_VALIDATION: {
    ko: "날짜 타입의 변수가 아닙니다.",
    en: "The selected variable is not of date type.",
  },
  NODE_DIALOG_DTC_RANGE_DATASET_VALIDATION: {
    ko: "Dataset에 group by 변수가 존재하지 않습니다.",
    en: "No group-by variable exists in the dataset.",
  },
  NODE_TOAST_DTC_RANGE_SUCCEED: {
    ko: "MINDTC, MAXDTC 생성을 완료했습니다.",
    en: "MINDTC and MAXDTC have been successfully created.",
  },
  NODE_TOAST_DTC_RANGE_FAIL: {
    ko: "MINDTC, MAXDTC 생성에 실패했습니다.",
    en: "Failed to create MINDTC and MAXDTC.",
  },
  NODE_TOAST_CLONE_SUCCEED: {
    ko: "값으로 데이터 세트 복제를 완료했습니다.",
    en: "The Clone Dataset by Value operation has been completed.",
  },
  NODE_TOAST_CLONE_FAIL: {
    ko: "값으로 데이터 세트 복제에 실패했습니다.",
    en: "Failed to clone the dataset by value.",
  },
  NODE_DRAWER_SDTM_MAPPING_TITLE: {
    ko: "SDTM 매핑",
    en: "SDTM Final Mapping",
  },
  NODE_DRAWER_SDTM_MAPPING_EMPTY_TITLE: {
    ko: "데이터가 없습니다.",
    en: "There is no SDTM Final Mapping data.",
  },
  NODE_DRAWER_SDTM_MAPPING_EMPTY_DESCRIPTION: {
    ko: "Target Dataset을 눌러\n데이터 세트를 불러 오세요.",
    en: "There is no SDTM Final Mapping data.\nClick Target Dataset to load the dataset.",
  },
  NODE_DRAWER_SDTM_MAPPING_SELECT_PLACEHOLDER: {
    ko: "선택...",
    en: "Select...",
  },
  NODE_DRAWER_SDTM_MAPPING_CONFIRM: CONVERTER_COMMON_LANG.CONFIRM_VERB,
  NODE_DRAWER_SDTM_MAPPING_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
  NODE_DRAWER_SDTM_MAPPING_PROGRESS: {
    ko: "진행률",
    en: "Progress",
  },
  NODE_DRAWER_SDTM_MAPPING_ONE_TO_ONE_SUCCEED: {
    ko: "1:1 할당을 완료했습니다.",
    en: "1:1 assignment has been completed.",
  },
  NODE_DRAWER_SDTM_MAPPING_ONE_TO_ONE_FAIL: {
    ko: "1:1 할당 수행에 실패했습니다.",
    en: "Failed to assign 1:1.",
  },
  NODE_DIALOG_SDTM_MAPPING_CT_TITLE: {
    ko: "지정 용어 적용",
    en: "Assign CT",
  },
  NODE_DIALOG_SDTM_MAPPING_CT_DESCRIPTION: {
    ko: "각 값에 해당하는 용어를 할당해 주세요.",
    en: "Select a term for each value.",
  },
  NODE_DRAWER_SDTM_MAPPING_CT_SUCCEED: {
    ko: "제어된 용어 적용을 수행했습니다.",
    en: "Controlled Terminology assignment has been completed.",
  },
  NODE_DRAWER_SDTM_MAPPING_CT_FAIL: {
    ko: "제어된 용어 적용 수행에 실패했습니다.",
    en: "Failed to assign Controlled Terminology.",
  },
  NODE_DIALOG_SDTM_MAPPING_FACTOR_TITLE: {
    ko: "변환계수 적용",
    en: "Conversion Factors",
  },
  NODE_DIALOG_SDTM_MAPPING_FACTOR_DESCRIPTION: {
    ko: "적용할 변환계수를 선택해 주세요.",
    en: "Select the conversion factor to apply.",
  },
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SUCCEED: {
    ko: "변환계수 적용을 완료했습니다.",
    en: "Conversion Factors applied successfully.",
  },
  NODE_DRAWER_SDTM_MAPPING_FACTOR_FAIL: {
    ko: "변환계수 적용에 실패했습니다.",
    en: "Failed to apply Conversion Factors.",
  },
  NODE_DRAWER_SDTM_MAPPING_NULL_SUCCEED: {
    ko: "null값 할당을 완료했습니다.",
    en: "Null assign completed successfully.",
  },
  NODE_DRAWER_SDTM_MAPPING_NULL_FAIL: {
    ko: "null값 할당에 실패했습니다.",
    en: "Failed to assign Null values.",
  },
  NODE_DRAWER_SDTM_MAPPING_SUCCEED: {
    ko: "SDTM 매핑을 완료했습니다.",
    en: "The SDTM Mapping operation has been completed.",
  },
  NODE_DRAWER_SDTM_MAPPING_FAIL: {
    ko: "SDTM 매핑에 실패했습니다.",
    en: "Failed to perform SDTM Mapping.",
  },
  NODE_DRAWER_SDTM_MAPPING_AUTO: {
    ko: "Auto Mapping",
    en: "Auto Mapping",
  },
  NODE_DRAWER_SDTM_MAPPING_SEQ_EMPTY_KEY_TOOLTIP: {
    ko: "Target Dataset의 Key 값이 설정되어 있지 않습니다.",
    en: "The Target Dataset does not have a configured key values.",
  },
  NODE_DRAWER_SDTM_MAPPING_SEQ_INVALID_DEFAULT_KEY_TOOLTIP: {
    ko: "Target Dataset의 Key 값 순서가 Partition 기준 변수 순서로 시작하지 않습니다.",
    en: "The key order of the target dataset does not begin with the partition key variables.",
  },
  NODE_DRAWER_SDTM_MAPPING_SEQ_UNMAPPED_TARGET_KEY_TOOLTIP: {
    ko: "Target Dataset의 Key로 설정된 변수 중 하나 이상이 매핑되지 않았습니다.",
    en: "One or more variables set as keys in the Target Dataset have not been mapped.",
  },
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SETTING_BUTTON: {
    ko: "변환계수 적용 설정",
    en: "Conversion Factor Setup",
  },
  NODE_DRAWER_SDTM_MAPPING_FACTOR_SETTING_TOOLTIP: {
    ko: " --TEST, --TESTCD, --ORRESU, --ORRES 매핑후 사용가능",
    en: "Enable after mapping --TEST, --TESTCD, --ORRESU, and --ORRES",
  },
  NODE_DRAWER_SDTM_MAPPING_RETAIN_ALL_CHECKBOX: {
    ko: "전체 변수 유지",
    en: "Retain All",
  },
  NODE_DRAWER_SDTM_MAPPING_SEQ_PARTITION_TITLE: {
    ko: "SEQ 파티션 설정",
    en: "SEQ Partition Configuration",
  },
  NODE_DRAWER_SDTM_MAPPING_SEQ_PARTITION_DESCRIPTION: {
    ko: "선택한 파티션 변수로 데이터가 그룹화되며, 파티션 변수로 설정되지 않은 나머지 키 변수는 그룹 내에서 --SEQ 번호 매김을 위한 정렬 기준(order by)으로 사용됩니다.\n\n각 파티션 내에서 --SEQ는 1부터 순차적으로 부여됩니다.",
    en: "Data is grouped by the selected partition variables. The remaining key variables not used as partitions are applied as the ordering criteria for --SEQ numbering within each group.\n\nThe --SEQ value is sequentially assigned starting from 1 within each partition.",
  },
  NODE_TOAST_SAVE_SUCCEED: {
    ko: "데이터 세트를 저장했습니다.",
    en: "The derived dataset has been saved.",
  },
  NODE_TOAST_SAVE_FAIL: {
    ko: "데이터 세트 저장에 실패했습니다.",
    en: "Failed to save the derived dataset.",
  },
  NODE_DIALOG_DELETE_TITLE: {
    ko: "삭제 확인",
    en: "Confirm Deletion",
  },
  NODE_DIALOG_DELETE_DESCRIPTION: {
    ko: "노드 삭제시 하위 노드들과의 관계가 끊어집니다.\n삭제하시겠습니까?",
    en: "When a node is deleted, its relationships with subordinate nodes will be disconnected.\nto proceed with the deletion?",
  },
  NODE_DIALOG_DELETE_USAGE_DESCRIPTION: {
    ko: "삭제 대상 파일(들)이 아래 흐름에서 사용되고 있습니다.\n파일을 삭제하실 경우 해당 흐름을 재 수행해야 하며, 흐름에 오류가 발생할 수 있습니다.\n해당 파일을 삭제 하시겠습니까?",
    en: "The file(s) you are trying to delete are used in the following flow(s).\nDeleting them will require re-running the flows and may cause errors.\nDo you want to proceed with deletion?",
  },
  NODE_TOAST_EXPORT_DELETE_FAIL: {
    ko: "해당 파일은 다른 흐름에서 참조하고 있으므로 삭제가 불가능합니다.",
    en: "This file cannot be deleted as it is referenced in another flow.",
  },
  NODE_TOAST_DELETE_SUCCEED: {
    ko: "데이터 세트를 삭제했습니다.",
    en: "The dataset has been deleted.",
  },
  NODE_TOAST_DELETE_FAIL: {
    ko: "데이터 세트 삭제에 실패했습니다.",
    en: "Failed to delete the dataset.",
  },
  NODE_TOAST_NAME_EXISTS: {
    ko: "이미 존재하는 이름입니다.",
    en: "The name already exists.",
  },
  NODE_DIALOG_FLOW_SAVE_ALERT_TITLE: {
    ko: "흐름 저장 요청",
    en: "Save Flow Request",
  },
  NODE_DIALOG_FLOW_SAVE_ALERT_DERIVED_DESCRIPTION: {
    ko: "파일 저장을 위해 현재 흐름을 저장해 주십시오.",
    en: "Please save the current flow to store the file.",
  },
  NODE_DIALOG_FLOW_SAVE_ALERT_SDTM_DESCRIPTION: {
    ko: "SDTM Mapping을 수행하기 위해 현재 흐름을 저장해 주십시오.",
    en: "Please save the current flow to perform SDTM mapping.",
  },
  NODE_DIALOG_FLOW_SAVE_PLACEHOLDER: {
    ko: "흐름명 입력",
    en: "Enter the flow name",
  },
  NODE_EXPORT_SAVE_REQUIRED_ALERT: {
    ko: "재저장 필요",
    en: "Save Required",
  },
  NODE_EXPORT_SAVE_REQUIRED_TOOLTIP: CONVERTER_COMMON_LANG.SAVE_VERB,
  NODE_EXPORT_SAVE_PROGRESS: {
    ko: "노드 생성 중입니다.\n잠시만 기다려 주세요.",
    en: "Creating node.\nThis may take a moment.",
  },
  NODE_SDTM_MAPPING_REQUIRED_ALERT: {
    ko: "매핑 재수행 필요",
    en: "Remap Required",
  },
  NODE_SOURCE_NOT_FOUND_ALERT: {
    ko: "소스 파일 삭제됨",
    en: "Source file deleted",
  },
  NODE_EXPORT_NOT_FOUND_ALRET: {
    ko: "출력 파일 삭제됨",
    en: "Output file deleted",
  },
  NODE_EXECUTION_FAILED_ALRET: {
    ko: "수행 중 오류",
    en: "Execution Failed",
  },
  NODE_ORPHAN_ALRET: {
    ko: "상위노드 삭제됨",
    en: "Parent node deleted",
  },
  NODE_TOAST_EDIT_SUCCEED: {
    ko: "설정 사항을 수정했습니다.",
    en: "The settings have been modified.",
  },
  NODE_TOAST_EDIT_FAIL: {
    ko: "설정 사항 수정에 실패했습니다.",
    en: "Failed to modify the settings.",
  },
  NODE_TOAST_SDTM_SAVE_FAIL: {
    ko: "동일한 이름의 파일('{source}')이 이미 존재합니다. 해당 파일을 삭제 하신 후 저장하시기 바랍니다.",
    en: "'{source}' already exists. Please delete it before saving.",
  },
  NODE_DIALOG_SOURCE_IMPORT_CONFIRM_TITLE: {
    ko: "데이터 타입 불일치",
    en: "Data Type Mismatch",
  },
  NODE_DIALOG_SOURCE_IMPORT_CONFIRM_DESCRIPTION: {
    ko: "데이터 타입 불일치가 있습니다. 재흐름 중 오류가 발생할 수 있습니다.",
    en: "Data type mismatches detected. Errors may occur during reflow.",
  },
  NODE_TOAST_SOURCE_IMPORT_SUCCEED: {
    ko: "파일 가져오기가 완료되었습니다.",
    en: "File import has been completed.",
  },
  NODE_TOAST_SOURCE_IMPORT_SCHEMA_FAIL: {
    ko: "파일 가져오기에 실패했습니다. 스키마 호환성 여부를 확인해 주십시오.",
    en: "Failed to import file. Please check schema compatibility.",
  },
  DATA_TABLE_TITLE: {
    ko: "데이터 테이블",
    en: "Data Table",
  },
  DATA_TABLE_EMPTY: {
    ko: "데이터가 없습니다.",
    en: "There is no data.",
  },
  DATA_TABLE_MENU_CREATE_DERIVED_VARIABLE: {
    ko: "파생 변수 생성",
    en: "Create Derived Variable",
  },
  DATA_TABLE_MENU_ORDER_BY: {
    ko: "정렬",
    en: "Order by",
  },
  DATA_TABLE_MENU_FILTER: {
    ko: "필터",
    en: "Filter",
  },
  DATA_TABLE_MENU_HISTORY: {
    ko: "수행 이력",
    en: "Execution History",
  },
  DATA_TABLE_MENU_REMOVE_DUPLICATES: {
    ko: "중복 제거",
    en: "Remove duplicates",
  },
  DATA_TABLE_MENU_PROCEDURE: {
    ko: "프로시저",
    en: "Procedure",
  },
  DATA_TABLE_MENU_PROCEDURE_VISITNUM: {
    ko: "VISITNUM 할당(비정규 방문)",
    en: "Assign VISITNUM(Unplanned Visits)",
  },
  DATA_TABLE_MENU_PROCEDURE_VISITNUM_TOOLTIP: {
    ko: "VISITNUM, VISIT, Date Type 변수가 존재할 경우 활성화",
    en: "Enabled if 'VISITNUM', 'VISIT' and Date Type variables exist.",
  },
  DATA_TABLE_DIALOG_ORDER_BY_TITLE: {
    ko: "정렬",
    en: "Order by",
  },
  DATA_TABLE_DIALOG_ORDER_BY_PLACEHOLDER: {
    ko: "변수",
    en: "Variable",
  },
  DATA_TABLE_DIALOG_MENU_ORDER_BY_ADD: {
    ko: "추가",
    en: "Add",
  },
  DATA_TABLE_DIALOG_MENU_ORDER_BY_DELETE: {
    ko: "삭제",
    en: "Delete",
  },
  DATA_TABLE_DIALOG_TOOLTIP_ORDER_BY_ASC: {
    ko: "오름차순",
    en: "Ascending Sort",
  },
  DATA_TABLE_DIALOG_TOOLTIP_ORDER_BY_DESC: {
    ko: "내림차순",
    en: "Descending Sort",
  },
  DATA_TABLE_TOAST_ORDER_BY_SUCCEED: {
    ko: "정렬 적용을 완료했습니다.",
    en: "Order by has been applied.",
  },
  DATA_TABLE_TOAST_ORDER_BY_FAIL: {
    ko: "정렬 적용에 실패했습니다.",
    en: "Failed to apply order by.",
  },
  DATA_TABLE_DIALOG_FILTER_TITLE: {
    ko: "필터",
    en: "Filter",
  },
  DATA_TABLE_DIALOG_FILTER_VARIABLE_PLACEHOLDER: {
    ko: "변수",
    en: "Variable",
  },
  DATA_TABLE_DIALOG_FILTER_INPUT_PLACEHOLDER: {
    ko: "입력",
    en: "Enter search term",
  },
  DATA_TABLE_DIALOG_FILTER_MENU_ADD: {
    ko: "필터 추가",
    en: "Add Filter",
  },
  DATA_TABLE_DIALOG_FILTER_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  DATA_TABLE_TOAST_FILTER_SUCCEED: {
    ko: "필터 적용을 완료했습니다.",
    en: "Filter has been completed.",
  },
  DATA_TABLE_TOAST_FILTER_FAIL: {
    ko: "필터 적용에 실패했습니다.",
    en: "Failed to apply filter.",
  },
  DATA_TABLE_DIALOG_HISTORY_TITLE: {
    ko: "수행 이력",
    en: "Execution History",
  },
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_ASC: {
    ko: "오름차순",
    en: "Ascending",
  },
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_DESC: {
    ko: "내림차순",
    en: "Descending Sort",
  },
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_UNDO: {
    ko: "실행 취소",
    en: "Undo",
  },
  DATA_TABLE_DIALOG_HISTORY_TOOLTIP_REDO: {
    ko: "다시 실행",
    en: "Redo",
  },
  DATA_TABLE_DIALOG_HISTORY_BADGE_FAIL: {
    ko: "실패",
    en: "Fail",
  },
  DATA_TABLE_HISTORY_TOOLTIP_EDIT: {
    ko: "설정 수정",
    en: "Edit Settings",
  },
  DATA_TABLE_HISTORY_TOOLTIP_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  DATA_TABLE_TOAST_HISTORY_DELETE_SUCCEED: {
    ko: "요청한 수행 이력을 삭제했습니다.",
    en: "Requested performance history deletion completed.",
  },
  DATA_TABLE_TOAST_HISTORY_DELETE_FAIL: {
    ko: "요청한 수행 이력 삭제에 실패했습니다.",
    en: "Failed to delete the requested performance history.",
  },
  DATA_TABLE_TOAST_HISTORY_SUCCEED: {
    ko: "요청한 수행 이력을 삭제했습니다.",
    en: "Requested performance history deletion completed.",
  },
  DATA_TABLE_TOAST_HISTORY_FAIL: {
    ko: "요청한 수행 이력 삭제에 실패했습니다.",
    en: "Failed to delete the requested performance history.",
  },
  DATA_TABLE_TOAST_REMOVE_DUPLICATES_SUCCEED: {
    ko: "중복값을 삭제했습니다.",
    en: "Duplicate value deletion has been completed.",
  },
  DATA_TABLE_TOAST_REMOVE_DUPLICATES_FAIL: {
    ko: "중복값 삭제에 실패했습니다.",
    en: "Failed to delete duplicate values.",
  },
  DATA_TABLE_FIELD_MENU_CREATE_DERIVED_VARIABLE: {
    ko: "파생 변수 생성",
    en: "Create Derived Variable",
  },
  DATA_TABLE_FIELD_MENU_FILTER: {
    ko: "필터",
    en: "Filter",
  },
  DATA_TABLE_FIELD_MENU_CDISC: {
    ko: "CDISC 변수 정보",
    en: "CDISC Variable Information",
  },
  DATA_TABLE_FIELD_MENU_AGGREGATE: {
    ko: "집계",
    en: "Aggregate",
  },
  DATA_TABLE_FIELD_MENU_REMOVE_DUPLICATES: {
    ko: "중복 제거",
    en: "Remove duplicates",
  },
  DATA_TABLE_FIELD_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  DATA_TABLE_FIELD_SORT: {
    ko: "정렬",
    en: "Sort",
  },
  DATA_TABLE_FIELD_ASC: {
    ko: "오름차순",
    en: "Ascending",
  },
  DATA_TABLE_FIELD_DESC: {
    ko: "내림차순",
    en: "Descending",
  },
  DATA_TABLE_POPOVER_AGGREGATE: {
    ko: "집계",
    en: "Agg.",
  },
  DATA_TABLE_POPOVER_AGGREGATE_EMPTY: {
    ko: "집계 내역이 없습니다.",
    en: "There is no aggregation result.",
  },
  DATA_TABLE_POPOVER_TOOLTIP_AGGREGATE: {
    ko: "집계",
    en: "Aggregated Distinct Values",
  },
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_TITLE: {
    ko: "중복제거",
    en: "Remove duplicates",
  },
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_DESCRIPTION: {
    ko: "중복제거 대상 변수를 선택해 주세요.",
    en: "Select the variable to be deduplicated.",
  },
  DATA_TABLE_DIALOG_REMOVE_DUPLICATES_PLACEHOLDER: {
    ko: "중복 대상 변수 선택",
    en: "Select the variable for duplicate removal. ",
  },
  DATA_TABLE_TOAST_VARIABLE_DELETE_SUCCEED: {
    ko: "{variable} 변수를 삭제했습니다.",
    en: "{variable} variable has been successfully deleted.",
  },
  DATA_TABLE_TOAST_VARIABLE_DELETE_FAIL: {
    ko: "{variable} 변수 삭제에 실패했습니다.",
    en: "Failed to delete the {variable} variable.",
  },
  DATA_TABLE_TOAST_VARIABLES_DELETE_SUCCEED: {
    ko: "변수(들)을 삭제했습니다.",
    en: "Variable(s) deleted successfully.",
  },
  DATA_TABLE_TOAST_VARIABLES_DELETE_FAIL: {
    ko: "변수(들) 삭제에 실패했습니다.",
    en: "Failed to delete the variable(s).",
  },
  DATA_TABLE_TOAST_VARIABLE_RENAME_FAIL: {
    ko: "이미 존재하는 변수명입니다.",
    en: "The variable name already exists.",
  },
  DATA_TABLE_FIELD_TYPE_DATE: {
    ko: "날짜형",
    en: "Date",
  },
  DATA_TABLE_FIELD_TYPE_DATETIME: {
    ko: "날짜시간형",
    en: "Datetime",
  },
  DATA_TABLE_FIELD_TYPE_TEXT: {
    ko: "문자형",
    en: "Text",
  },
  DATA_TABLE_FIELD_TYPE_INTEGER: {
    ko: "정수형",
    en: "Integer",
  },
  DATA_TABLE_FIELD_TYPE_FLOAT: {
    ko: "실수형",
    en: "Float",
  },
  DATA_TABLE_TOAST_TYPE_CASTING_SUCCESS: {
    ko: "{variable}의 데이터 타입을 {type}으로 변경했습니다.",
    en: "The data type of {variable} has been changed to {type}.",
  },
  DATA_TABLE_TOAST_TYPE_CASTING_FAIL: {
    ko: "{variable}의 데이터 타입 변경에 실패했습니다.",
    en: "Failed to change the data type of {variable}.",
  },
  DATA_TABLE_TOAST_UNSUPPORTED_TYPE_CASTING_FAIL: {
    ko: "변경할 수 없는 데이터 타입입니다.",
    en: "This data type cannot be changed.",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_TITLE: {
    ko: "VISITNUM 할당(비정규 방문)",
    en: "Assign VISITNUM(Unplanned Visits)",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_DESCRIPTION: {
    ko: "VISITNUM을 계산하기 위해 아래 항목의 값을 지정해 주세요.",
    en: "Configure the following settings to proceed with VISITNUM calculation.",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_SUBJECT_ID_PLACEHOLDER: {
    ko: "대상자 아이디 정보를 가진 변수 선택",
    en: "Select a variable containing the subject ID.",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISITDTC_PLACEHOLDER: {
    ko: "SVSTDTC로 매핑될 방문일자 변수 선택",
    en: " Select the variable to map to SVSTDTC.",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISITNUM_PLACEHOLDER: {
    ko: "VISITNUM 데이터를 가진 변수 선택",
    en: "The variable containing the VISITNUM value",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_VISIT_PLACEHOLDER: {
    ko: "VISIT 데이터를 가진 변수 선택",
    en: "The variable containing the VISIT value",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_PLACEHOLDER: {
    ko: "비정규 방문 정보가 입력된 변수 선택",
    en: "Select a variable for unplanned visit information",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_VALUE_PLACEHOLDER: {
    ko: "비정규 방문에 대한 값 선택",
    en: "Select a value for unplanned visit",
  },
  DATA_TABLE_DIALOG_PROCEDURE_VISITNUM_UNPLANNED_VISIT_FORMAT_PLACEHOLDER: {
    ko: "비정규 방문을 명시하는 용어 입력",
    en: "Enter a term for an unscheduled visit",
  },
  DATA_TABLE_TOAST_PROCEDURE_VISITNUM_SUCCEED: {
    ko: "VISITNUM 적용을 완료했습니다.",
    en: "VISITNUM has been completed.",
  },
  DATA_TABLE_TOAST_PROCEDURE_VISITNUM_FAIL: {
    ko: "VISITNUM 적용에 실패했습니다.",
    en: "Failed to apply VISITNUM.",
  },
  DATA_TABLE_DIALOG_PROCEDURE_DEFAULT_VISITNUM_CHIP: {
    ko: "{이번 VISITNUM}",
    en: "{This VISITNUM}",
  },
  DATA_TABLE_DIALOG_PROCEDURE_DEFAULT_VISIT_CHIP: {
    ko: "{이번 정규방문 VISIT}",
    en: "{This Planned VISIT}",
  },
  POPOVER_CDISC_INFORMATION: {
    ko: "CDISC 변수 정보",
    en: "CDISC Variable Information",
  },
  TOOLTIP_MORE: {
    ko: "더보기",
    en: "More Option",
  },

  FUNCTION_EDITOR_DRAWER_TITLE: {
    ko: "파생 변수 생성",
    en: "Create Derived Variable",
  },
  FUNCTION_EDITOR_DRAWER_VARIABLE_PLACEHOLDER: {
    ko: "계산 결과를 할당할 새로운 변수 이름",
    en: "New variable name for the calculation result",
  },
  FUNCTION_EDITOR_DRAWER_SEARCH_PLACEHOLDER: {
    ko: "찾을 함수 이름",
    en: "Function name to search",
  },
  FUNCTION_EDITOR_DRAWER_EXAMPLE_TEXT: {
    ko: "예시",
    en: "Example",
  },
  FUNCTION_EDITOR_DRAWER_ERROR_MESSAGE: {
    ko: "오류가 발생했습니다.\n작성하신 구문(참조한 변수 타입 일치 여부 등)을 확인해 주시기 바랍니다.",
    en: "An error has occurred.\nPlease check your syntax and ensure that referenced variable types are consistent.",
  },
  FUNCTION_EDITOR_DRAWER_CANCEL: {
    ko: "취소",
    en: "Cancel",
  },
  FUNCTION_EDITOR_DRAWER_EXECUTE: {
    ko: "수행",
    en: "Execute",
  },
  FUNCTION_EDITOR_DRAWER_COMMIT: {
    ko: "저장",
    en: "Commit",
  },
  FUNCTION_EDITOR_TOAST_EXECUTE_SUCCEED: {
    ko: "함수를 이용한 데이터 생성이 완료되었습니다.",
    en: "The data has been successfully derived using the function.",
  },
  FUNCTION_EDITOR_TOAST_EXECUTE_FAIL: {
    ko: "함수를 이용한 데이터 생성에 실패했습니다.",
    en: "Failed to derive data using the function.",
  },
  FUNCTION_EDITOR_TOAST_COMMIT_SUCCEED: {
    ko: "파생 데이터 저장이 완료되었습니다",
    en: "Function-based derived data has been successfully saved.",
  },
  FUNCTION_EDITOR_TOAST_COMMIT_FAIL: {
    ko: "파생 데이터 저장에 실패했습니다.",
    en: "Failed to save the derived data using the function.",
  },
  FUNCTION_IS_NULL_DESCRIPTION: {
    ko: "입력된 값이 NULL이면 1을 반환하고, NULL이 아니면 0을 반환합니다. 조건문에서 NULL 여부를 확인할 때 사용합니다.",
    en: "Returns 1 if the input value is NULL, and 0 if it is not. Useful for checking whether a value is NULL in conditional expressions.",
  },
  FUNCTION_IF_NULL_DESCRIPTION: {
    ko: "지정한 값이 NULL인 경우, 대체값(<return>)을 반환합니다. 값이 NULL이 아니면 원래 값을 그대로 반환합니다.",
    en: "Returns the specified replacement value if the input is NULL. If the input is not NULL, it returns the original value.",
  },
  FUNCTION_IF_DESCRIPTION: {
    ko: "조건식을 순서대로 평가하여, 처음으로 참이 되는 조건에 해당하는 값을 반환합니다. 모든 조건이 거짓일 경우 ELSE에 지정된 값을 반환합니다.",
    en: "Evaluates conditions in order and returns the value corresponding to the first condition that is true. If none of the conditions are true, the value defined in the ELSE clause is returned.",
  },
  FUNCTION_CASE_DESCRIPTION: {
    ko: "일련의 조건을 평가하고, 조건이 충족될 때 첫 번째로 일치하는 값을 반환합니다.",
    en: "It evaluates a series of conditions and returns the value corresponding to the first one that is met.",
  },
  FUNCTION_ROUND_DESCRIPTION: {
    ko: "지정한 자릿수에서 숫자를 반올림하여 반환합니다. number_digit가 0이면 정수로 반올림되며, 음수일 경우 해당 자릿수 앞에서 반올림됩니다.",
    en: "Rounds a number to the specified number of decimal places.",
  },
  FUNCTION_SUBSTRING_DESCRIPTION: {
    ko: "문자열에서 지정한 시작 위치부터 주어진 길이만큼의 문자를 추출합니다.",
    en: "Extracts a substring from the input string, starting at the specified position and for the specified length.",
  },
  FUNCTION_REPLACE_DESCRIPTION: {
    ko: "문자열에서 지정한 value1을 value2로 변경합니다. value2에 빈 문자열을 지정하면 해당 문자열은 제거됩니다.",
    en: "Replaces the specified value1 with value2 in a string. If value2 is set to empty string, the matched value will be removed from the string.",
  },
  FUNCTION_CONCAT_DESCRIPTION: {
    ko: "여러 문자열을 연결하여 하나의 문자열로 반환합니다.",
    en: "Merges multiple strings into a single string.",
  },
  FUNCTION_GREATEST_DESCRIPTION: {
    ko: "동일 행(row) 내 여러 컬럼 값을 비교할 때 사용하며, 여러 입력 값 중에서 가장 큰 값을 반환합니다.",
    en: "Used to compare multiple column values within the same row and returns the greatest value among the inputs.",
  },
  FUNCTION_LEAST_DESCRIPTION: {
    ko: "동일 행(row) 내 여러 컬럼 값을 비교할 때 사용하며, 여러 입력 값 중에서 가장 작은 값을 반환합니다.",
    en: "Used to compare multiple column values within the same row and returns the least (smallest) value among the inputs.",
  },
  FUNCTION_STRPDATE_DESCRIPTION: {
    ko: "첫 번째 파라메터는 날짜 값을 가진 문자형식의 날, 두 번째 파라메트는 첫 번째 파라메터의 포멧을 설명하는 패턴이며, 각 패턴을 표기하는 인자는 아래와 같습니다.",
    en: "The STRPTIME function takes two parameters:\n\n1. A string representing a date.\n2. A pattern string that specifies the format of the first parameter.\n\nThe format specifiers are as follows:",
  },
  FUNCTION_STRPDATE_DETAIL: {
    ko: [
      "%d : Zero padding한 날짜",
      "%b : 축약한 영문 월(예 : Mar) 형태",
      "%B : 영문 월 (예 : March)",
      "%m : zero padding된 숫자 형태의 월 (예 : 5 → 05)",
      "%y : 년도(세기를 뺀 년도, 2자리 년도, 예 : 25 → 2025)",
      "%Y : 년도(세기를 포함한 년도, 4자리 년도, 예 : 2025)",
    ].join("\n"),
    en: [
      "%d : Day of the month with zero padding (e.g., 05)",
      "%b : Abbreviated month name in English (e.g., Mar)",
      "%B : Full month name in English (e.g., March)",
      "%m : Month as a zero-padded number (e.g., 05 for May)",
      "%y : Year without century, two digits (e.g., 25 → 2025)",
      "%Y : Year with century, four digits (e.g., 2025)",
    ].join("\n"),
  },
  FUNCTION_STRPTIME_DESCRIPTION: {
    ko: "첫 번째 파라메터는 날짜 값을 가진 문자형식의 날, 두 번째 파라메트는 첫 번째 파라메터의 포멧을 설명하는 패턴이며, 각 패턴을 표기하는 인자는 아래와 같습니다.",
    en: "The STRPTIME function takes two parameters:\n\n1. A string representing a date and/or time.\n2. A pattern string that specifies the format of the first parameter.\n\nThe format specifiers are as follows:",
  },
  FUNCTION_STRPTIME_DETAIL: {
    ko: [
      "%d : Zero padding한 날짜",
      "%b : 축약한 영문 월(예 : Mar) 형태",
      "%B : 영문 월 (예 : March)",
      "%m : zero padding된 숫자 형태의 월 (예 : 5 → 05)",
      "%y : 년도(세기를 뺀 년도, 2자리 년도, 예 : 25 → 2025)",
      "%Y : 년도(세기를 포함한 년도, 4자리 년도, 예 : 2025)",
      "%H:%M:%S : 24시간으로 입력된 값을 파싱하여 표준 시간으로 변환 (예 : 02:03:20 → 02:03:20 로 리턴)",
      "%I:%M:%S %p : 12시간과 오전,오후로 입력된 값을 파싱하여 24간 표준 시간으로 변환 (예 : 04:20:06 pm → 16:20:06 으로 리턴, 04:20:06 am → 04:20:06 으로 리턴)",
    ].join("\n"),
    en: [
      "%d : Day of the month with zero padding (e.g., 05)",
      "%b : Abbreviated month name in English (e.g., Mar)",
      "%B : Full month name in English (e.g., March)",
      "%m : Month as a zero-padded number (e.g., 05 for May)",
      "%y : Year without century, two digits (e.g., 25 → 2025)",
      "%Y : Year with century, four digits (e.g., 2025)",
      "%H:%M:%S : Parses a 24-hour formatted time into standard time (e.g., 02:03:20 → 02:03:20).",
      "%I:%M:%S %p : Parses a 12-hour formatted time with AM/PM and converts it into 24-hour standard time (e.g., 04:20:06 pm → 16:20:06, 04:20:06 am → 04:20:06).",
    ].join("\n"),
  },
  FUNCTION_WINDOW_RANK_DESCRIPTION: {
    ko: "그룹 내 정렬 기준에 따라 순위를 부여하며, 동일 순위는 공유하고 다음 순위는 건너뜁니다.",
    en: "Ranks rows within each group; tied ranks share the same value and skip the next rank.",
  },
  FUNCTION_WINDOW_DENSE_RANK_DESCRIPTION: {
    ko: "그룹 내 정렬 기준으로 순위를 부여하며, 동일 값은 같은 순위를, 이후 순위는 건너뛰지 않고 부여됩니다.",
    en: "Ranks rows in each group; ties share ranks and next ranks increase without gaps (DENSE_RANK logic).",
  },
  FUNCTION_WINDOW_ROW_NUMBER_DESCRIPTION: {
    ko: "그룹 내 정렬 기준에 따라 고유한 번호를 부여하며, 동일 순위 없이 1부터 순차적으로 부여됩니다.",
    en: "Assigns unique row numbers per group based on sort order; no ties allowed.",
  },
  FUNCTION_WINDOW_MAX_DESCRIPTION: {
    ko: "그룹별로 [Variable]의 최댓값을 계산하며, 계산된 값은 해당 그룹의 모든 행에 동일하게 부여됩니다.",
    en: "Returns the maximum of [Variable] per group; the result is applied to all rows in that group.",
  },
  FUNCTION_WINDOW_MIN_DESCRIPTION: {
    ko: "그룹별로 [Variable]의 최솟값을 계산하고, 그 값을 그룹 내 모든 행에 동일하게 적용합니다.",
    en: "Returns the minimum of [Variable] per group; the result is applied to all rows in that group.",
  },

  DIALOG_SAVE: CONVERTER_COMMON_LANG.SAVE_VERB,
  DIALOG_CONFIRM: CONVERTER_COMMON_LANG.CONFIRM_VERB,
  DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
  DIALOG_SAVEAS: {
    ko: "다른 이름으로 저장",
    en: "Save As",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_DATA_FLOW_LANG);
